export default __webpack_public_path__ + "static/media/Frame.730b975f.png";